import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const TempleWalletPopup = ({
  showTemplePopup,
  setShowTemplePopup,
  connectWallet,
  qrCode,
}) => {
  if (!showTemplePopup) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Connect with Temple Wallet</h2>
        <p>Use your Temple Wallet browser extension to connect.</p>

        {/* Use Extension Button */}
        <button className="connect-btn" onClick={connectWallet}>
          Use Extension
        </button>

        {/* QR Code Option */}
        <div className="qr-section">
          <p>Or scan to connect:</p>

          <QRCodeCanvas value={qrCode} size={150} />
          {/* <img src="./img/wallet/walletqr.svg" alt="wallet-qr" /> */}
        </div>

        <button className="close-btn" onClick={() => setShowTemplePopup(false)}>
          Close
        </button>
      </div>
    </div>
  );
};

export default TempleWalletPopup;
